import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

// Attention case should be respected
export default function yearsReducer(state = initialState.years, action: any) {
  switch (action.type) {
    case types.SAVE_YEARS_SUCCESS:
      return action.years;
    default:
      return state;
  }
}
